import React from "react";
import 'react-tooltip/dist/react-tooltip.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'animate.css/animate.css';
import './src/scss/global.scss';
import Clarity from '@microsoft/clarity';


export const onRouteUpdate = ({ location }) => {
    window.scrollTo(0, 0);
};

export const wrapRootElement = ({ element }) => (
    <>
      {element}      
    </>
);


// Make sure to add your actual project id instead of "yourProjectId".
const projectId = "s958zmb6cb"

Clarity.init(projectId);